import {getParentElementsContainingClass, mediaQueryBreakpointMD} from "../Utils/Utils";

const Menu1 = () => {

	document.querySelectorAll('#menu-1 .menu-item').forEach((menuItem) => {
		const subMenu = menuItem.querySelector('.sub-menu');
		if(subMenu) {
			menuItem.addEventListener('mouseover', (e) => {
				if(window.innerWidth >= mediaQueryBreakpointMD) {
					e.currentTarget.classList.add('js-reveal-sub-menu');
				}
			});
			menuItem.addEventListener('mouseleave', (e) => {
				if(window.innerWidth >= mediaQueryBreakpointMD) {
					e.currentTarget.classList.remove('js-reveal-sub-menu');
				}
			});
		}
	});

	if(document.body.classList.contains('single-post')) {
		document.querySelectorAll('.menu_page-news').forEach(menuItem => {
			menuItem.classList.add('js-active');
			const parentMenuItems = getParentElementsContainingClass(menuItem, 'menu-item');
			parentMenuItems.forEach(pItem => pItem.classList.add('js-active'));
		});
	}
	else if(document.body.classList.contains('single-offer')) {
		document.querySelectorAll('.menu_page-offers').forEach(menuItem => {
			menuItem.classList.add('js-active');
			const parentMenuItems = getParentElementsContainingClass(menuItem, 'menu-item');
			parentMenuItems.forEach(pItem => pItem.classList.add('js-active'));
		});
	}
	else if(document.body.classList.contains('single-room')) {
		document.querySelectorAll('.menu_page-rooms').forEach(menuItem => {
			menuItem.classList.add('js-active');
			const parentMenuItems = getParentElementsContainingClass(menuItem, 'menu-item');
			parentMenuItems.forEach(pItem => pItem.classList.add('js-active'));
		});
	}
};

export default Menu1;